import { Injectable } from '@angular/core';
import { EXPORT_TYPE_MESSAGE, ExportType, TableExportUtil } from './tableExportUtil';
import type { ExportTotalizador, TableElement } from './tableExportUtil';
import Swal from './swal.util';

@Injectable({
    providedIn: 'root'
})
export class TableExportService {
    async export(type: ExportType, data: Partial<TableElement>[], fileName: string, totalizadores?: ExportTotalizador[]): Promise<void> {
        if (!data || data.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Nenhum dado encontrado para exportação',
                text: 'Verifique os filtros aplicados ou tente novamente mais tarde.',
                confirmButtonText: 'OK'
            });
            return;
        }

        Swal.fire({
            title: EXPORT_TYPE_MESSAGE[type],
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        try {
            await this.executar(type, data, fileName, totalizadores);
            setTimeout(() => Swal.close(), 600);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao exportar arquivo' });
            console.error('Erro ao exportar:', err);
        }
    }

    private executar(type: ExportType, data: Partial<TableElement>[], fileName: string, totalizadores?: ExportTotalizador[]): void | Promise<void> {
        switch (type) {
            case ExportType.Excel:
                return TableExportUtil.exportToExcel(data, fileName, totalizadores);
            case ExportType.Ods:
                return TableExportUtil.exportToODS(data, fileName, totalizadores);
            case ExportType.Csv:
                return TableExportUtil.exportToCSV(data, fileName, totalizadores);
            case ExportType.Pdf:
                return TableExportUtil.exportToPDF(data, fileName, totalizadores);
            case ExportType.Json:
                return TableExportUtil.exportToJSON(data, fileName, totalizadores);
            case ExportType.Clipboard:
                return TableExportUtil.exportToClipboard(data, totalizadores);
            case ExportType.Print:
                return TableExportUtil.exportToPrint();
            case ExportType.PrintPdf:
                return TableExportUtil.exportToPrintPdf(data, fileName, totalizadores);
            case ExportType.Xml:
                return TableExportUtil.exportToXml(data, fileName, totalizadores);
            default:
                throw new Error(`Tipo de exportação não suportado: ${type}`);
        }
    }
}
